import { defineStore } from 'pinia'
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';


export const diamondQuizStore = defineStore('diamondQuiz',{
    state: () => {
        return {
            payload:{
                PriceFrom: 0,
                PriceTo: 0,
                Shape:'',
                Sort:'',
                Color: '',
                Clarity:'',
            },
            price:{
                min:0,
                max:0,
            },
            totalPages:5,
            currentPage: 1,
            result:[]
        }
    },

    getters: { ...getters },
    actions: {
        ...actions, commitMutation: function (mutationToCall, data) {

            try {
                mutations[mutationToCall](this, data)
            } catch (error) {
                console.error('DIAMONDQUIZ MUTATION ERROR - ', mutationToCall, data, error)
                throw error
            }
        }
    },
    
})


